<template>
    <div class="border-tips" :style="{'width': width}" v-html="msg">
    </div>
</template>
<script>
export default {
    props: {
        msg: String,
        width: String
    }
}
</script>
<style lang="scss"  >
    .border-tips{
        position: absolute;
        padding: 16px;
        backdrop-filter: blur(10px);
        box-shadow: 1px 3px 8px 0 rgba(3, 6, 52, 0.08);
        border: solid 1px #3942b5;
        background-color: #ffffff;
        border-radius: 4px;
        margin-top: 6px;
        line-height: 1.5;
        box-sizing: border-box;
        z-index: 2;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/borderTips.vue